import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class PortalAndLineupApplicationConnectionService {
  private static readonly returnUrlKey = 'portalReturnUrl';
  constructor(private router: Router) {}

  setReturnUrl(url: string): void {
    if (url && !url.startsWith('/portal/forms')) {
      sessionStorage.setItem(PortalAndLineupApplicationConnectionService.returnUrlKey, url);
    }
  }
  hasReturnUrl(): boolean {
    return (
      sessionStorage.getItem(PortalAndLineupApplicationConnectionService.returnUrlKey) !== null
    );
  }
  backToPortal(): void {
    const returnUrl =
      sessionStorage.getItem(PortalAndLineupApplicationConnectionService.returnUrlKey) ?? '/portal';
    sessionStorage.removeItem(PortalAndLineupApplicationConnectionService.returnUrlKey);
    this.router.navigateByUrl(returnUrl);
  }
  setFormReturnUrl(url: string): void {
    localStorage.setItem('formReturnUrl', url);
  }
  removeFormReturnUrl(): void {
    localStorage.removeItem('formReturnUrl');
  }
  hasFormReturnUrl(): boolean {
    return localStorage.getItem('formReturnUrl') !== null;
  }
  backToFormReturnUrl(): void {
    const returnUrl = localStorage.getItem('formReturnUrl');
    if (returnUrl) {
      localStorage.removeItem('formReturnUrl');
      this.router.navigateByUrl(returnUrl);
    } else {
      this.router.navigateByUrl('/portal');
    }
  }
}
